import { http } from "../http";

export const login = (data: any) => {
  return http.post("auth/admin-login", data);
};

export const setUserStatus = ({ id, isActive }: any) => {
  return http.patch(`users/${id}/status`, { isActive });
};

export const getUsers = ({ queryKey }: any) => {
  return http.get("users", {
    params: {
      ...queryKey[1],
    },
  });
};

export const getUserById = ({ queryKey }: any) => {
  return http.get(`users/${queryKey[1]}`);
};

export const postUser = (data: any) => {
  return http.post("users", data);
};

export const updateUser = ({ userId, data }: any) => {
  return http.patch(`users/${userId}`, data);
};

export const updateUserStatus = ({ userId, data }: any) => {
  return http.patch(`users/${userId}`, data);
};

// Family Member APIs
export const getFamilyMembers = ({ queryKey }: any) => {
  return http.get(`family-member`, {
    params: {
      userId: queryKey[1],
    },
  });
};

export const getFamilyMemberById = ({ queryKey }: any) => {
  // queryKey[1] = familyMemberId, queryKey[2] = userId (optional for admin)
  return http.get(`family-member/${queryKey[1]}`, {
    params: queryKey[2] ? { userId: queryKey[2] } : {},
  });
};

export const postFamilyMember = (data: any) => {
  // data should include userId for admin to specify which user's family member to create
  return http.post("family-member", data);
};

export const updateFamilyMember = ({ familyMemberId, data }: any) => {
  // data should include userId for admin to specify which user's family member to update
  return http.patch(`family-member/${familyMemberId}`, data);
};

export const deleteFamilyMember = ({ id, userId }: { id: string; userId?: string }) => {
  // userId param for admin to specify which user's family member to delete
  return http.delete(`family-member/${id}`, {
    params: userId ? { userId } : {},
  });
};

export const updateFamilyMemberPassword = ({
  familyMemberId,
  userId,
  data,
}: {
  familyMemberId: string;
  userId: string;
  data: { username: string; password: string };
}) => {
  return http.patch(`family-member/${familyMemberId}/update-password`, data, {
    params: { userId },
  });
};

// Address APIs
export const getAddresses = ({ queryKey }: any) => {
  return http.get(`addresses`, {
    params: {
      userId: queryKey[1],
    },
  });
};

export const getAddressById = ({ queryKey }: any) => {
  return http.get(`addresses/${queryKey[1]}`);
};

export const postAddress = (data: any) => {
  return http.post("addresses", data);
};

export const updateAddress = ({ addressId, data }: any) => {
  return http.patch(`addresses/${addressId}`, data);
};

export const deleteAddress = (id: string) => {
  return http.delete(`addresses/${id}`);
};

// Relations API
export const getRelations = () => {
  return http.get("users/relations");
};

// Documents API
export const getUserDocuments = ({ queryKey }: any) => {
  return http.get(`users/documents`, {
    params: {
      userId: queryKey[1],
    },
  });
};

// Property APIs
export const getPropertyTypes = () => {
  return http.get("property/types");
};

export const getPropertyOwnershipStatus = () => {
  return http.get("property/ownership");
};

export const getPropertyTypeOptions = () => {
  return http.get("property/type");
};

export const postProperty = (data: any) => {
  // data should include userId for admin to specify which user's property to create
  return http.post("property", data);
};

export const getPropertyById = ({ queryKey }: any) => {
  // queryKey[1] = propertyId, queryKey[2] = userId (optional for admin)
  return http.get(`property/${queryKey[1]}`, {
    params: queryKey[2] ? { userId: queryKey[2] } : {},
  });
};

export const updateProperty = ({ propertyId, data }: any) => {
  // data should include userId for admin to specify which user's property to update
  return http.patch(`property/${propertyId}`, data);
};

export const deleteProperty = ({ id, userId }: { id: string; userId?: string }) => {
  // userId param for admin to specify which user's property to delete
  return http.delete(`property/${id}`, {
    params: userId ? { userId } : {},
  });
};
